//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheBlockHeader from "@/components/TheBlockHeader.vue";
import LinksSquareObject from "@/components/objects/public/shared-blocks/links/objects/LinksSquareObject";

export default {
  name: "Square",
  components: {
    LinksSquareObject,
    TheBlockHeader
  },
  inject: {
    specialProject: {
      default: false
    }
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    objectLabel: {
      type: String,
      default: ''
    },
    useStorage: {
      type: Boolean
    },
    design: {
      type: String,
    },
    template: {
      type: Object,
    },
    listInfo: {
      type: Object,
    },
    user: {
      type: Object,
      default: () => {}
    },
  },

  data() {
    return {
      isMobile: false,
      domId: ''
    }
  },

  computed: {
    linkItems() {
      return this.items.filter(i => !i.loader)
    },
    showLoadMore() {
      return this.items.some(i => i.loader)
    },
    showHead() {
      return this.linkItems.length === 1 || !this.showFake || this.isMobile
    },
    showInfo() {
      return (this.linkItems.length === 1 || this.linkItems.length % 4 !== 0 && !this.isMobile) || (this.linkItems.length % 2 !== 0 && this.isMobile)
    },
    showFake() {
      return this.linkItems.length % 4 === 2
    },
    showDoubledFake() {
      return this.linkItems.length % 4 === 1 && this.linkItems.length !== 1
    }
  },

  mounted() {
    this.domId = 'links-' + this.listInfo.id
    window.addEventListener('resize', this.resizeHandler, { passive: true })
  },

  created() {
    if (process.client) {
      this.resizeHandler()
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },

  methods: {
    resizeHandler() {
      this.isMobile = Boolean(window.innerWidth < 640)
    }
  }
}
